import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { displayNotification, empty, getAPIURL, sendAPIRequest } from "../../../../helpers";
import DataTable from "../../../components/DataTable";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import {  useSelector } from "react-redux";
import Crumbs from "components/crumbs/Crumbs";
import AddExpertToolDocumentModal from "modules/pvs_activities/components/Modal/AddExpertToolDocumentModal";
import moment from "moment";
import { MissionContext } from "modules/pvs_activities/components/contexts/MissionTasksContext";
const Index = ({ showOther = true }) => {
    const missionContext = useContext(MissionContext)
    const { t } = useTranslation();
    const [isShow, setIsShow] = useState(false);
    const uploadModel = () => setIsShow(!isShow);
    const crumbs = [
        { path: "/portal/metadata-management", label: t("2", "Metadata Management"), active: false },
        {
            label: t("573", "Expert Tool Documents"),
            active: true,
        },
    ];
    const authToken = useSelector((s) => s.auth.accessToken);
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        loadData()
    }, [isShow]);

    const loadData = async () => {
        setIsLoading(true);
        try {
            const req = await sendAPIRequest(`/api/pvsa/expert-tool-document`);
            const res = await req.json();

            if (res.success) {
                setData(res.data);
            } else {
                displayNotification('error', `${t("589", "Error loading data")} [B]`);
            }
        } catch (error) {
            console.error("Error loading data:", error);
            displayNotification('error', `${t("589", "Error loading data")} [F]`);
        }
        setIsLoading(false);
    };

    const handleDelete = async (id) => {
        try {
            if (!window.confirm(t("590", "You are about to delete a country. Are you sure?"))) {
                return;
            }
            const req = await sendAPIRequest(`/api/pvsa/expert-tool-document/${id}`, "DELETE");
            const res = await req.json();
            if (res.success) {
                displayNotification('success', `${t("591", "Successfully deleted data")} [B]`);
                loadData();
            } else {
                displayNotification('error', `${t("592", "Error deleting data")} [B]`);
            }
        } catch (e) {
            console.log(e);
            displayNotification('error', `${t("592", "Error deleting data")} [F]`);
        }
    };
    return (
        <>
            <div className={(showOther ? " container my-2" : "")}>
                {
                    showOther && (
                        <>
                            <Crumbs crumbs={crumbs} />
                        </>
                    )
                }
                <div className="header card-woah border border-secondary d-flex px-4 py-2 shadow-sm w-100 my-2 justify-content-between">
                    <div className="card-title1 lh-1">{t("-1", "Expert Toolbox ")}</div>
                    {
                        showOther &&
                        <div className="header-right-items d-flex">
                            <Link to={"/portal/metadata-management"} className="ms-auto">
                                <button className="btn btn--primary fs-7 lh-1">
                                    {" "}
                                    <i className="fas fa-angle-left text-white" />
                                    {t("32", "Back")}
                                </button>
                            </Link>

                            <button className="btn btn--outline fs-7 lh-1" onClick={() => uploadModel()}>
                                <span className="align-middle">{t("-1", "Add New Expert Tool Document")}</span>
                                <i className="fas fa-plus align-middle text-black ms-2 mt-1" />
                            </button>

                        </div>
                    }
                </div>
                <div className="card card-woah border border-secondary shadow rounded-0">
                    <div className="card-body p-4">
                        <DataTable
                            getRowId={(row) => row.id}
                            isLoading={false}
                            className="text-white bg-primary rounded-0"
                            rows={data}
                            columns={[
                                {
                                    field: "actual_name",
                                    headerName: t("-1", "Document Name"),
                                    headerClassName: "text-white bg-primary rounded-0",
                                    minWidth: 150,
                                    flex: 1,
                                },
                                {
                                    field: "createdAt",
                                    headerName: t("-1", "Timestamp"),
                                    valueGetter: ({ value }) => (!empty(value) ? value : null),
                                    valueFormatter: ({ value }) =>
                                        !empty(value)
                                            ? moment(value).format("DD-MMMM-YYYY (hh:mm A)")
                                            : "",
                                    headerClassName: "text-white bg-primary rounded-0",
                                    minWidth: 100,
                                    flex: 1,
                                },
                                {
                                    field: "file_identifier",
                                    headerName: t("-1", "Key"),
                                    headerClassName: "text-white bg-primary rounded-0",
                                    minWidth: 150,
                                    flex: 1,
                                },
                                {
                                    field: "actions",
                                    type: "actions",
                                    headerClassName: "text-white bg-primary rounded-0",
                                    headerName: t("-1", "Actions"),
                                    getActions: (params) => {
                                        const actions = [];
                                        actions.push(
                                            <GridActionsCellItem
                                                label={"Download Document"}
                                                key={`downloadform-${params.row?.id}`}
                                                showInMenu
                                                onClick={() =>
                                                    window.open(
                                                        getAPIURL(
                                                            `/api/pvsa/expert-tool-document/download/${params.row?.id}?_token=${authToken}`,
                                                            "_target"
                                                        )
                                                    )
                                                }
                                            />,
                                        );
                                        if (missionContext && !missionContext.is_archived) {
                                            actions.push(<GridActionsCellItem
                                                label={"Delete"}
                                                showInMenu
                                                onClick={() => handleDelete(params.row.id)}
                                            />)
                                        }
                                        return actions;
                                    },
                                },
                            ]}
                        />
                    </div>
                </div>
            </div>
            {
                isShow &&
                <AddExpertToolDocumentModal
                    isShow={isShow}
                    uploadModel={uploadModel}
                />
            }
        </>
    );
};

export default Index;
